import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWeb3 } from '../context/Web3Context';
import ConnectButton from '../components/Wallet/ConnectButton';
import Button from '../components/Common/Button';

const FEATURES = [
  { icon: '◆', title: 'Daily ROI', desc: 'Earn up to 1% daily across 5 staking plans up to 360 days.' },
  { icon: '⚏', title: '15-Level Rewards', desc: 'Earn up to 100% level income from your downline ROI.' },
  { icon: '★', title: 'Real-time Stats', desc: 'Live dashboards with full transparency of every transaction.' },
  { icon: '◐', title: 'Secure Smart Contract', desc: 'Audited Solidity protocol on BNB Chain.' }
];

const Home = () => {
  const { account } = useWeb3();
  const navigate = useNavigate();

  return (
    <div className="landing">
      <div className="landing-hero">
        <h1 className="landing-title">AMSG STAKING</h1>
        <p className="landing-subtitle">
          The next-generation USDT staking protocol with up to 360% ROI
          and a 15-level rewards network on BNB Chain.
        </p>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
          {!account ? (
            <ConnectButton />
          ) : (
            <Button variant="primary" size="lg" onClick={() => navigate('/dashboard')}>
              Enter Dashboard
            </Button>
          )}
          <Button variant="outline" size="lg" onClick={() => navigate('/invest')}>
            Start Staking
          </Button>
        </div>
      </div>

      <div className="landing-features">
        {FEATURES.map((f, i) => (
          <div key={i} className="feature-card">
            <div className="feature-icon">{f.icon}</div>
            <div className="feature-title">{f.title}</div>
            <div className="feature-desc">{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
